import type React from 'react';
import BylineList from 'components/Byline';
import ArticleHeroEyebrow from 'components/ArticleHeroEyebrow';
import type { Article } from 'interfaces/content/articles/Articles';
import { SocialLinksContainer } from 'components/SocialLinks/SocialLinksStyles';
import SpinningLoader from 'components/Loader/SpinningLoader';
import ErrorBoundary from 'components/ErrorBoundary';
import { UIFragments } from 'utils/log/constants/uiFragments';
import {
  ArticleSocialAndContentContainer,
  ArticleSocialContainer,
  SponsoredSidebarContainer,
  ArticleContentContainer,
  ArticleHeroWrapper,
  ArticleHeroTitle,
  ArticleHeroBylineWrapper,
  ArticleHeroAuthorsContainer,
  ArticleHeroDate,
  ArticleImageAndContentContainer,
  ArticleContentWrapper,
  ArticleAdBlocker,
} from './SponsoredStyles';

export interface SponsoredProps {
  article: Article;
}

const SponsoredPage: React.FC<SponsoredProps> = ({ article }) => {
  const { primaryPostTag, primarySection } = article;

  const authorStandIn = {
    email: '',
    image: '',
    name: '',
    sameAs: '',
    type: '',
    uri: '',
    url: '',
  };

  return (
    <article id='content'>
      <ArticleHeroWrapper>
        <ErrorBoundary fragment={UIFragments.SPONSORED}>
          <ArticleHeroEyebrow
            primarySection={primarySection}
            primaryPostTag={primaryPostTag}
            className='nativo-content__eyebrow'
          />
        </ErrorBoundary>
        <ArticleHeroTitle
          className='nativo-content__heading'
          as='h1'
          $fontFamily='saol'
          $size={{ default: 'level3', mdMin: 'large' }}
        />
        <ArticleHeroBylineWrapper className='nativo-content__byline'>
          <ErrorBoundary fragment={UIFragments.SPONSORED}>
            <ArticleHeroAuthorsContainer>
              <BylineList
                bylineList={[authorStandIn]}
                isArticle
                nativoClassName='nativo-content__author'
              />
            </ArticleHeroAuthorsContainer>
          </ErrorBoundary>
          <ArticleHeroDate className='nativo-content__publish-date' />
        </ArticleHeroBylineWrapper>
      </ArticleHeroWrapper>
      <ErrorBoundary fragment={UIFragments.SPONSORED}>
        <ArticleContentContainer>
          <ArticleImageAndContentContainer className='nativo-content__right-side'>
            <ArticleSocialAndContentContainer>
              <ArticleSocialContainer>
                <SocialLinksContainer className='nativo-content__social' />
              </ArticleSocialContainer>
              <ArticleContentWrapper className='nativo-content__body-content'>
                <div
                  key='article-content'
                  className='rawHtml-content'
                />
                <ArticleAdBlocker className='nativo-content__ad-blocker'>
                  <SpinningLoader
                    className='spinning-loader'
                    show
                  />
                  To view this content, you may be required to disable your ad blocker.
                </ArticleAdBlocker>
              </ArticleContentWrapper>
            </ArticleSocialAndContentContainer>
          </ArticleImageAndContentContainer>
          <SponsoredSidebarContainer className='nativo-content__right-rail' />
        </ArticleContentContainer>
      </ErrorBoundary>
    </article>
  );
};
export default SponsoredPage;
